require('../../modules/esnext.typed-array.filter-out');
